import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

const DOCS_ICON_LIST:any = {
  PDF: 'assets/icons/DOCUMENT_TYPE_PDF.svg',
  DOC: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  DOCX: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  XLS: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  XLSX: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  PPT: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  PPTX: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  RAR: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  ZIP: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  HTML: 'assets/icons/DOCUMENT_TYPE_HTML.svg',
  TXT: 'assets/icons/DOCUMENT_TYPE_TXT.svg',
  JPG: 'assets/icons/DOCUMENT_TYPE_JPG.svg',
  PNG: 'assets/icons/DOCUMENT_TYPE_PNG.svg',
  SVG: 'assets/icons/DOCUMENT_TYPE_SVG.svg',
  AI: 'assets/icons/DOCUMENT_TYPE_AI.svg',
}

@Component({
  selector: 'app-list-documents',
  templateUrl: './list-documents.component.html',
  styleUrls: ['./list-documents.component.scss']
})
export class ListDocumentsComponent implements OnInit {

  @Input() documents: any[] = [];
  @Input() showType: boolean = false;
  @Input() showDescription: boolean = false;
  @Input() showDelete: boolean = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  private apiUrl = '/api/';
  locale = 'fr';

  constructor(
    private confirmDialogService: ConfirmationDialogService
  ) { }

  ngOnInit(): void {
  }

  getFileExt(doc:any):string {
    if(doc.fileName){
      let tabExt = (doc.fileName).split('.');
      let ext = String(tabExt[tabExt.length - 1]).toUpperCase() || 'PDF';
      return DOCS_ICON_LIST[ext];
    }else{
      return '';
    }
  }

  openDocument(document:any){
    window.open(this.apiUrl + document.url, '_blank');
  }

  deleteDocument(event:any, document:any){
    event.stopPropagation();

    this.confirmDialogService
      .confirm(
        'modal.item.delete.title',
        'modal.item.delete.message',
      )
      .then(confirmed => {
        if (confirmed) {
          this.onDelete.emit(document);
        }
      })
      .catch(() => {
        /* dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)*/
      });

    
  }

}
